import { HttpErrorResponse } from '@angular/common/http';
import { SearchOption, Sku } from '@emi/shared/models';
import { createAction, props } from '@ngrx/store';

export const getSkuSearchResults = createAction(
    '[SkuSearch] Load Sku Search Results',
    props<{ searchTerm: string; searchOption: SearchOption, sortBy?:string, orderBy?:string,
         includeSearchPhrase?:boolean }>()
);

export const getSkuSearchResultsSuccess = createAction(
    '[SkuSearch] Load Sku Search Results Successful',
    props<{ results: Sku[]; skuCount: number; nextPageId: string }>()
);

export const getSkuSearchResultsFailure = createAction(
    '[SkuSearch] Load Sku Search Results Failure',
    props<{ error: HttpErrorResponse }>()
);

export const getNextPageSkuSearchResults = createAction('[SkuSearch] Get Next Page of Sku Search Responses');

export const updateSkuSearchResultsSuccess = createAction(
    '[SkuSearch] Get Next Page Sku Search Responses Success',
    props<{ results: Sku[]; nextPageId: string }>()
);

export const setCurrency = createAction('[SkuSearch] Set currency', props<{ currency: string }>());

export const setSortBy = createAction('[SkuSearch] Set sort by', props<{ sortBy: string }>());

export const setOrderBy = createAction('[SkuSearch] Set order by', props<{ orderBy: string }>());

export const getSkuCount = createAction('[SkuSearch] Get sku count');

export const getSkuCountSuccess = createAction('[SkuSearch] Update sku count', props<{ skuCount: number }>());

export const getSkuCountFailure = createAction('[SkuSearch] Get sku count failure', props<{ error: HttpErrorResponse }>());

export const clearSearchResults = createAction(
    '[SkuSearch] Clear Search Results',
    props<{ searchTerm: string; searchOption: SearchOption }>()
);
